import { browserHistory } from 'react-router';

import { BUDGET_BASE_ROUTE } from '.';

const handleBudgetRouteChange = (location?: string, preventIfUnsaved = true) => {
  browserHistory.replace({
    pathname: `${BUDGET_BASE_ROUTE}${location || ''}`,
    state: { preventIfUnsaved },
  });
};

export default handleBudgetRouteChange;
